import React from 'react';
import { Check, X, Minus } from 'lucide-react';

const rows = [
  {
    feature: 'Founder personally teaches you',
    them: { icon: 'x', text: 'Multiple trainers, not the founder' },
    us: 'Deepak Singhai takes every class',
  },
  {
    feature: 'NISM Certified Trainer',
    them: { icon: 'm', text: 'Team certified, not always your trainer' },
    us: 'Deepak Singhai personally NISM RA Certified',
  },
  {
    feature: 'Small batch — personal attention',
    them: { icon: 'x', text: 'Large batches — you are a number' },
    us: 'Small batches — genuine personal attention',
  },
  {
    feature: 'Direct access to your mentor',
    them: { icon: 'x', text: 'Hard to reach the founder directly' },
    us: 'Direct WhatsApp access to Deepak Singhai',
  },
  {
    feature: 'Post-course support',
    them: { icon: 'm', text: 'Limited or paid for extended support' },
    us: 'Continued guidance after course completion',
  },
  {
    feature: 'Live market in small group setting',
    them: { icon: 'm', text: 'Available but in large groups' },
    us: 'Live market every session, small group',
  },
  {
    feature: 'Boutique focused learning environment',
    them: { icon: 'x', text: 'Corporate setup — feels impersonal' },
    us: 'Focused, warm, personal classroom',
  },
];

const ThemIcon = ({ icon }) => {
  if (icon === 'x') return <X className="h-4 w-4 text-red-400 inline mr-1.5" strokeWidth={3} />;
  if (icon === 'm') return <Minus className="h-4 w-4 text-yellow-400 inline mr-1.5" strokeWidth={3} />;
  return null;
};

const Comparison = () => {
  return (
    <section className="bg-zinc-950 py-16 sm:py-20" id="compare" data-testid="comparison-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="mb-10 sm:mb-12">
          <div className="inline-flex items-center gap-1.5 bg-white/10 text-white/70 px-3.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3">
            Honest Comparison
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-3">
            How We Compare to Other <span className="text-green-400">Bhopal Institutes</span>
          </h2>
          <p className="text-base sm:text-lg text-white/55 max-w-2xl">
            An honest look at what makes Stocks Vision Academy different for students who want certified, personal mentorship.
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl">
          <table className="w-full border-collapse min-w-[640px]" data-testid="comparison-table">
            <thead>
              <tr>
                <th className="text-left text-xs font-bold uppercase tracking-wider text-white/40 bg-white/5 px-5 py-4 w-[38%]">
                  What Matters to You
                </th>
                <th className="text-center text-xs font-bold uppercase tracking-wider text-white/35 bg-white/[0.06] px-5 py-4 border-l border-white/10">
                  Other Institutes
                </th>
                <th className="text-center text-xs font-bold uppercase tracking-wider text-white bg-green-600 px-5 py-4 border-l border-white/10">
                  ✓ Stocks Vision Academy
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.feature}>
                  <td className="text-sm text-white/65 font-medium bg-white/[0.02] px-5 py-3.5 border-b border-white/[0.06]">
                    {r.feature}
                  </td>
                  <td className="text-sm text-center text-white/40 bg-white/[0.02] px-5 py-3.5 border-l border-b border-white/[0.06]">
                    <ThemIcon icon={r.them.icon} />
                    {r.them.text}
                  </td>
                  <td className="text-sm text-center text-green-300 font-semibold bg-green-600/10 px-5 py-3.5 border-l border-b border-green-600/20">
                    <Check className="h-4 w-4 text-green-400 inline mr-1.5" strokeWidth={3} />
                    {r.us}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
